const DEFAULT_MAX_SIZE = 10 * 1024 * 1024; // 10 MB

const MIME_TYPES = [
	// General
	{ mimeType: "application/pdf", name: "PDF Document", extension: ".pdf" },
	{ mimeType: "application/msword", name: "Word Document", extension: ".doc" },
	{ mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", name: "Word Document", extension: ".docx" },
	{ mimeType: "application/vnd.ms-excel", name: "Excel Spreadsheet", extension: ".xls" },
	{ mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", name: "Excel Spreadsheet", extension: ".xlsx" },
	{ mimeType: "application/vnd.ms-powerpoint", name: "PowerPoint Presentation", extension: ".ppt" },
	{ mimeType: "application/vnd.openxmlformats-officedocument.presentationml.presentation", name: "PowerPoint Presentation", extension: ".pptx" },
	{ mimeType: "application/zip", name: "ZIP Archive", extension: ".zip" },
	{ mimeType: "application/x-rar-compressed", name: "RAR Archive", extension: ".rar" },
	{ mimeType: "application/x-7z-compressed", name: "7-Zip Archive", extension: ".7z" },
	{ mimeType: "application/json", name: "JSON File", extension: ".json" },
	{ mimeType: "application/xml", name: "XML File", extension: ".xml" },
	{ mimeType: "text/plain", name: "Text File", extension: ".txt" },
	{ mimeType: "text/csv", name: "CSV File", extension: ".csv" },
	{ mimeType: "text/html", name: "HTML File", extension: ".html" },
	{ mimeType: "text/css", name: "CSS File", extension: ".css" },
	{ mimeType: "text/javascript", name: "JavaScript File", extension: ".js" },
	{ mimeType: "application/rtf", name: "Rich Text Document", extension: ".rtf" },
	{ mimeType: "application/octet-stream", name: "Binary File", extension: "" },
	{ mimeType: "application/gzip", name: "GZIP Archive", extension: ".gz" },
	// Image
	{ mimeType: "image/png", name: "PNG Image", extension: ".png" },
	{ mimeType: "image/jpeg", name: "JPEG Image", extension: ".jpg" },
	{ mimeType: "image/gif", name: "GIF Image", extension: ".gif" },
	{ mimeType: "image/webp", name: "WebP Image", extension: ".webp" },
	{ mimeType: "image/svg+xml", name: "SVG Image", extension: ".svg" },
	{ mimeType: "image/bmp", name: "BMP Image", extension: ".bmp" },
	{ mimeType: "image/tiff", name: "TIFF Image", extension: ".tiff" },
	{ mimeType: "image/x-icon", name: "ICO Image", extension: ".ico" },
	{ mimeType: "image/vnd.microsoft.icon", name: "ICO Image", extension: ".ico" },
	{ mimeType: "image/avif", name: "AVIF Image", extension: ".avif" },
	{ mimeType: "image/apng", name: "Animated PNG", extension: ".apng" },
	{ mimeType: "image/heic", name: "HEIC Image", extension: ".heic" },
	{ mimeType: "image/heif", name: "HEIF Image", extension: ".heif" },
	{ mimeType: "image/jxl", name: "JPEG XL Image", extension: ".jxl" },
	{ mimeType: "image/jp2", name: "JPEG 2000 Image", extension: ".jp2" },
	{ mimeType: "image/x-ms-bmp", name: "BMP Image", extension: ".bmp" },
	{ mimeType: "image/psd", name: "Photoshop Document", extension: ".psd" },
	{ mimeType: "image/x-tga", name: "TGA Image", extension: ".tga" },
	{ mimeType: "image/x-pcx", name: "PCX Image", extension: ".pcx" },
	{ mimeType: "image/vnd.adobe.photoshop", name: "Photoshop Document", extension: ".psd" }
];

const MIME_TYPE_MAP = new Map(MIME_TYPES.map(entry => [entry.mimeType, entry]));

export function getFileTypeForMimeType(mimeType) {
	const key = (mimeType || "").toLowerCase();
	return MIME_TYPE_MAP.get(key) || { mimeType: key, name: key, extension: "" };
}

export function parseMimeTypes(mimeTypeString) {
	if(!mimeTypeString) {
		return [];
	}

	return mimeTypeString.split(";")
		.map(t => t.trim().toLowerCase())
		.filter(Boolean);
}

export function isAcceptedMimeType(fileType, allowedMimeTypes) {
	if(!allowedMimeTypes || allowedMimeTypes.length === 0) {
		return true;
	}

	return allowedMimeTypes.includes((fileType || "").toLowerCase());
}

export function isAllowedSize(fileSize, maxSizeInBytes) {
	return fileSize <= (maxSizeInBytes ?? DEFAULT_MAX_SIZE);
}

export function formatSize(size) {
	if(size === 0 || size === undefined) {
		return "0 B";
	}

	const units = ["B", "KB", "MB", "GB"];
	let idx = 0;
	let scaled = size;

	while(scaled >= 1024 && idx < units.length - 1) {
		scaled = scaled / 1024;
		idx += 1;
	}

	return `${scaled.toFixed(1)} ${units[idx]}`;
}

export function buildValidationOptions(mimeTypes, sizeInBytes) {
	return {
		mimeTypes: parseMimeTypes(mimeTypes),
		maxSize: sizeInBytes ?? DEFAULT_MAX_SIZE
	};
}

export function createBlobUrl(data, mimeType) {
	const blob = new Blob([data], { type: mimeType || "application/octet-stream" });
	return URL.createObjectURL(blob);
}

export function triggerFileDownload(data, fileName, mimeType) {
	const url = createBlobUrl(data, mimeType);

	const el = angular.element("<a/>");
	el.attr({
		href: url,
		target: "_blank",
		download: fileName || "download"
	});

	el.one("click", () => {
		setTimeout(() => URL.revokeObjectURL(url), 30000);
	});

	el[0].click();
}
